import * as React from 'react'

import { makeStyles } from '@fluentui/react-components'

import Header from './components/Header'
import Footer from './components/Footer'
import Error from './components/Error'

import EmailCardsContainer from './containers/EmailCardsContainer'
import SearchBoxContainer from './containers/SearchBoxContainer'

import rootStyle from './styles/root'
import emailCardStyle from './styles/email-card'

const { emailCardsContainer } = emailCardStyle

const useStyles = makeStyles({
  ...rootStyle,
  emailCardsContainer
})

const App = (props) => {
  const { title } = props

  const [messages, setMessages] = React.useState([])
  const [searchParams, setSearchParams] = React.useState(null)
  const [error, setError] = React.useState(null)
  const [hasMoreMessages, setHasMoreMessages] = React.useState(false)

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Header logo='assets/icon.png' title={title} />

      {error && <Error error={error} />}

      <SearchBoxContainer
        messages={messages}
        setMessages={setMessages}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        setHasMoreMessages={setHasMoreMessages}
        setError={setError}
      />

      {messages.length !== 0 &&
        <div className={classes.emailCardsContainer}>
          <EmailCardsContainer
            messages={messages}
            setMessages={setMessages}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            hasMoreMessages={hasMoreMessages}
            setHasMoreMessages={setHasMoreMessages}
          />
        </div>}

      <Footer />
    </div>
  )
}

export default App
